import React, { useMemo, useState } from "react";
import { XCircle, CheckCircle } from "lucide-react";
import ModalPortal from "../../../shared/ui/ModalPortal"; // عدّلي المسار حسب مكانه عندك

const empty = {
  clientId: "",
  noteContent: "",
  outcome: "",
};

export default function SalesNoteFormModal({ initialData, clients, onClose, onSubmit }) {
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(() => ({
    ...empty,
    ...(initialData || {}),
    clientId:
      initialData?.clientId !== undefined && initialData?.clientId !== null
        ? String(initialData.clientId)
        : "",
  }));

  const title = useMemo(() => (initialData ? "Edit Note" : "Add Note"), [initialData]);
  const change = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = async () => {
    if (!String(form.clientId || "").trim()) return alert("Client is required");
    if (!String(form.noteContent || "").trim()) return alert("Note content is required");

    setSaving(true);
    try {
      const payload = {
        clientId: Number(form.clientId),
        noteContent: String(form.noteContent || "").trim(),
outcome: String(form.outcome || "").trim() || null,
      };
      await onSubmit?.(payload);
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalPortal onClose={onClose}>
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onMouseDown={onClose} />

      {/* Center */}
      <div className="absolute inset-0 flex items-center justify-center p-4 overflow-y-auto">
        <div
          role="dialog"
          aria-modal="true"
          className="w-full max-w-4xl bg-white/10 backdrop-blur-2xl border border-white/20 shadow-[0_0_40px_rgba(255,0,255,0.3)] rounded-2xl overflow-hidden my-10"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="p-6 bg-gradient-to-r from-pink-600 to-purple-700 flex justify-between items-center">
            <h2 className="text-2xl font-bold text-white">{title}</h2>
            <button onClick={onClose} className="text-white hover:text-gray-200" disabled={saving} title="Close">
              <XCircle className="w-7 h-7" />
            </button>
          </div>

          <div className="p-6 max-h-[70vh] overflow-y-auto text-white">
            <div className="grid md:grid-cols-2 gap-4">
              <Box label="Client">
                <select value={form.clientId} onChange={change("clientId")} className={selectCls} disabled={saving}>
                  <option value="" className="text-black">
                    Select client
                  </option>
                  {(clients || []).map((c) => (
                    <option key={c.id} value={String(c.id)} className="text-black">
                      {c.companyName || `Client #${c.id}`}
                    </option>
                  ))}
                </select>
              </Box>

              <Box label="Outcome">
                <input
                  value={form.outcome || ""}
                  onChange={change("outcome")}
                  className={inputCls}
                  disabled={saving}
                  placeholder="e.g. Interested / Follow-up"
                />
              </Box>

              <div className="md:col-span-2">
                <Box label="Note Content">
                  <textarea
                    value={form.noteContent || ""}
                    onChange={change("noteContent")}
                    className={inputCls + " min-h-[140px] resize-y"}
                    disabled={saving}
                    placeholder="Write the sales note here..."
                  />
                </Box>
              </div>
            </div>

            <div className="flex gap-4 mt-6">
              <button
                onClick={submit}
                disabled={saving}
                className="flex-1 py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-pink-500 to-red-500 shadow-lg hover:opacity-90 disabled:opacity-40 flex items-center justify-center gap-2"
              >
                <CheckCircle className="w-5 h-5" />
                {saving ? "Saving..." : "Save"}
              </button>

              <button
                onClick={onClose}
                className="flex-1 py-3 rounded-xl font-semibold bg-gray-600 hover:bg-gray-700 text-white disabled:opacity-40"
                disabled={saving}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
}

function Box({ label, children }) {
  return (
    <div className="bg-white/10 border border-white/20 rounded-xl p-4 backdrop-blur-xl">
      <label className="text-sm text-gray-200">{label}</label>
      <div className="mt-2">{children}</div>
    </div>
  );
}

const inputCls =
  "w-full px-3 py-2 bg-white/10 text-white border border-white/20 rounded-lg outline-none focus:ring-2 focus:ring-pink-400/30";
const selectCls =
  "w-full px-3 py-2 bg-white/10 text-white border border-white/20 rounded-lg outline-none focus:ring-2 focus:ring-pink-400/30";
